import { Button } from "react-admin";
import { Store } from "../utils/store";

const clearLocalSettings = () => {
  console.log("Reseting storage");
  Store.flip("RaStore.version");
  window.location.reload();
};

export const ClearLocalSettingsButton = (props) => {
  return (
    <Button
      label="Clear local settings"
      {...props}
      onClick={clearLocalSettings}
    />
  );
};
